module.exports = __webpack_public_path__ + "img/title.97ec44f4.png";